import GoodsDetail from './goods_detail.vue'

export default {
    path: 'goodsDetail',
    component: GoodsDetail
}
